module.exports = __webpack_public_path__ + "img/header_bg1.05f7b682.jpg";